export class Persona {
  private idObjeto: number;
  private apellido: string;
  private nombre: string;
  private email: string | null;
  private tipo: string;
  private nroDoc: string;
  private password: string;

  constructor(
    idObjeto: number,
    apellido: string,
    nombre: string,
    email: string | null,
    tipo: string,
    nroDoc: string,
    password: string
  ) {
    this.idObjeto = idObjeto;
    this.apellido = apellido;
    this.nombre = nombre;
    this.email = email;
    this.tipo = tipo;
    this.nroDoc = nroDoc;
    this.password = password;
  }

  // Métodos getter
  getIdObjeto(): number {
    return this.idObjeto;
  }

  getApellido(): string {
    return this.apellido;
  }

  getNombre(): string {
    return this.nombre;
  }

  getEmail(): string | null {
    return this.email;
  }

  getTipo(): string {
    return this.tipo;
  }

  getNroDoc(): string {
    return this.nroDoc;
  }

  getPassword(): string {
    return this.password;
  }

  // Métodos setter
  setIdObjeto(idObjeto: number): void {
    this.idObjeto = idObjeto;
  }

  setApellido(apellido: string): void {
    this.apellido = apellido;
  }

  setNombre(nombre: string): void {
    this.nombre = nombre;
  }

  setEmail(email: string | null): void {
    this.email = email;
  }

  setTipo(tipo: string): void {
    this.tipo = tipo;
  }

  setNroDoc(nroDoc: string): void {
    this.nroDoc = nroDoc;
  }

  setPassword(password: string): void {
    this.password = password;
  }

  // Método fromCollection para crear una instancia de Persona desde un objeto
  static fromCollection(data: any): Persona {
    return new Persona(
      data.id_objeto,
      data.apellido,
      data.nombre,
      data.email,
      data.tipo,
      data.nro_doc,
      data.password
    );
  }

  // Método toString para representar la instancia como una cadena
  toString(): string {
    return `Persona: { id_objeto: ${this.idObjeto}, apellido: ${this.apellido}, nombre: ${this.nombre}, email: ${this.email}, tipo: ${this.tipo}, nro_doc: ${this.nroDoc}, password: ${this.password} }`;
  }
}
